import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: any, limit: number = 20): string {
    if (value === null || value === undefined) return '';
    const str = String(value);
    return str.length > limit ? str.substring(0, limit) + '...' : str;
  }
}
